import fe_config from "constants/Configs";
import { CLIENTS } from "constants";
import TokenManager from "utils/TokenManager";
import { getStore } from "storeRef";

const { MODE, CLIENT_IDS_TO_HIDE_CHARTS } = fe_config;

/**
 * function name should be 'page_type_name'
 */

export function getConfigVariable(name, configVariables) {
  try {
    const store = configVariables ? null : getStore();
    const state = store && store.getState();
    const variable =
      configVariables?.[name] ?? state?.configVariables?.[name] ?? [];
    if (typeof variable === "string") {
      return variable
        .split(",")
        .map((id) => parseInt(id.trim()))
        .filter((id) => !isNaN(id));
    }
    return variable;
  } catch (error) {
    return [];
  }
}

const clientId = () => TokenManager.getClientId();

export function enableDEVandDemoOnly() {
  const CLIENT_IDS_FOR_DEMO =
    getConfigVariable("FE_ENABLE_FEATURES_FOR_DEMO") ||
    fe_config.CLIENT_IDS_FOR_DEMO;
  return MODE === "DEV" || CLIENT_IDS_FOR_DEMO.includes(clientId());
}

export function enableCollectorGoal() {
  // Visible to admins, AR reps, and read-only AR users; controlled by CLIENT_COLLECTOR_GOAL_ENABLED feature flag
  return (
    TokenManager.getIsAdmin() ||
    TokenManager.getIsAR_REP() ||
    TokenManager.isReadOnlyARUser()
  );
}

export function vendorlist_chart_paymentmix() {
  const CLIENT_IDS_FOR_DEMO =
    getConfigVariable("FE_ENABLE_FEATURES_FOR_DEMO") ||
    fe_config.CLIENT_IDS_FOR_DEMO;
  return MODE === "DEV" || CLIENT_IDS_FOR_DEMO.includes(clientId());
}
export function vendorlist_chart_paymentmethod() {
  const CLIENT_IDS_FOR_DEMO =
    getConfigVariable("FE_ENABLE_FEATURES_FOR_DEMO") ||
    fe_config.CLIENT_IDS_FOR_DEMO;
  return MODE === "DEV" || CLIENT_IDS_FOR_DEMO.includes(clientId());
}
export function customerlist_edit_workflow() {
  return !TokenManager.getIsUserOnly();
}
export function payablelist_column_paymentmethod() {
  const CLIENT_IDS_FOR_DEMO =
    getConfigVariable("FE_ENABLE_FEATURES_FOR_DEMO") ||
    fe_config.CLIENT_IDS_FOR_DEMO;
  return MODE === "DEV" || CLIENT_IDS_FOR_DEMO.includes(clientId());
}
export function setting_ar_rep_settings() {
  return TokenManager.getIsAR_REP() || TokenManager.isReadOnlyARUser();
}
export function setting_company_userdetails() {
  return TokenManager.getHighestRoleId() < 3;
}
export function setting_company_financialgoals() {
  return TokenManager.getIsAdmin() && !TokenManager.getIsEntityAdmin();
}
export function setting_company_accounts_update() {
  return !TokenManager.getIsUserOnly();
}
export function setting_company_paymentconnection() {
  return (
    TokenManager.getIsGroupAdmin() ||
    TokenManager.getIsPayAdmin() ||
    TokenManager.getIsAdminOnly()
  );
}
export function setting_company_permissions() {
  return MODE === "DEV" && !TokenManager.getIsUserOnly();
}
export function setting_company_general() {
  return !TokenManager.getIsUserOnly() && !TokenManager.getIsEntityAdmin();
}
export function setting_company_companyheirarchy() {
  return TokenManager.getIsPayAdmin() || TokenManager.getIsGroupAdmin();
}
export function setting_company_corpentities() {
  return !TokenManager.getIsUserOnly();
}
export function setting_data_integrations() {
  return !TokenManager.getIsEntityAdmin();
}
export function setting_data_import() {
  return !TokenManager.getIsEntityAdmin();
}
export function insights_ap_chart_paymenttermsbyvalue() {
  const CLIENT_IDS_FOR_DEMO =
    getConfigVariable("FE_ENABLE_FEATURES_FOR_DEMO") ||
    fe_config.CLIENT_IDS_FOR_DEMO;
  return MODE === "DEV" || CLIENT_IDS_FOR_DEMO.includes(clientId());
}

export function hideChartsForClientProd() {
  return MODE === "PROD" && CLIENT_IDS_TO_HIDE_CHARTS.includes(clientId());
}

export const enableAPIForAdaptive = () => {
  const FE_ENABLE_BEGINNING_CASH_CF = getConfigVariable(
    "FE_ENABLE_BEGINNING_CASH_CF"
  );
  return (
    (MODE === "DEV" && FE_ENABLE_BEGINNING_CASH_CF.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_BEGINNING_CASH_CF.includes(clientId()))
  );
};

export const checkAutoPayCheckDefault = () => {
  const FE_ENABLE_AUTOPAY_DEFAULT_CHECK = getConfigVariable(
    "FE_ENABLE_AUTOPAY_DEFAULT_CHECK"
  );
  return (
    (MODE === "DEV" && FE_ENABLE_AUTOPAY_DEFAULT_CHECK.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_AUTOPAY_DEFAULT_CHECK.includes(clientId()))
  );
};

export function callNewAPTotalInDev() {
  const FE_USE_NEW_AP_TOTAL_IN_DEV = getConfigVariable(
    "FE_USE_NEW_AP_TOTAL_IN_DEV"
  );
  return (
    MODE === "DEV" ||
    (MODE === "PROD" && FE_USE_NEW_AP_TOTAL_IN_DEV.includes(clientId()))
  );
}

export function reconcileFilterChangeForDemo() {
  const FE_RECONCILE_FILTER_CHANGE_FOR_DEMO = getConfigVariable(
    "FE_RECONCILE_FILTER_CHANGE_FOR_DEMO"
  );
  return (
    (MODE === "PROD" &&
      FE_RECONCILE_FILTER_CHANGE_FOR_DEMO.includes(clientId())) ||
    (MODE === "DEV" && FE_RECONCILE_FILTER_CHANGE_FOR_DEMO.includes(clientId()))
  );
}

export function enableCreateInvoice() {
  const FE_ENABLE_CREATE_INVOICE_DEMO_PAGE = getConfigVariable(
    "FE_ENABLE_CREATE_INVOICE_DEMO_PAGE"
  );
  return (
    (MODE === "PROD" &&
      FE_ENABLE_CREATE_INVOICE_DEMO_PAGE.includes(clientId())) ||
    MODE === "DEV"
  );
}

export function enableStatementFieldsGSC() {
  const FE_ENABLE_DRIVER_ACTIVITY_FEATURE = getConfigVariable(
    "FE_ENABLE_DRIVER_ACTIVITY_FEATURE"
  );
  return (
    (MODE === "PROD" &&
      FE_ENABLE_DRIVER_ACTIVITY_FEATURE.includes(clientId())) ||
    (MODE === "DEV" && FE_ENABLE_DRIVER_ACTIVITY_FEATURE.includes(clientId()))
  );
}

export function enableEditInvoiceButtonEmail() {
  const FE_ENABLE_EDIT_INVOICE_BUTTON_IN_MANUAL_EMAIL = getConfigVariable(
    "FE_ENABLE_EDIT_INVOICE_BUTTON_IN_MANUAL_EMAIL"
  );
  return (
    (MODE === "PROD" &&
      FE_ENABLE_EDIT_INVOICE_BUTTON_IN_MANUAL_EMAIL.includes(clientId())) ||
    (MODE === "DEV" &&
      FE_ENABLE_EDIT_INVOICE_BUTTON_IN_MANUAL_EMAIL.includes(clientId()))
  );
}

export function enableCustomerDepositTabForNonNetSuite() {
  const FE_ENABLE_CUSTOMER_DEPOSIT_TAB_FOR_NON_NETSUITE = getConfigVariable(
    "FE_ENABLE_CUSTOMER_DEPOSIT_TAB_FOR_NON_NETSUITE"
  );
  return (
    MODE === "PROD" &&
    FE_ENABLE_CUSTOMER_DEPOSIT_TAB_FOR_NON_NETSUITE.includes(clientId())
  );
}

export function enableCategoryLevelTotal() {
  const FE_ENABLE_CF_CATEGORY_LEVEL_TOTALS = getConfigVariable(
    "FE_ENABLE_CF_CATEGORY_LEVEL_TOTALS"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_CF_CATEGORY_LEVEL_TOTALS.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_CF_CATEGORY_LEVEL_TOTALS.includes(clientId()))
  );
}

export function hideCustomFieldForHardHatCustomer() {
  //no migration to be done as very specific function for hardhat
  return (
    (MODE === "DEV" && [198].includes(clientId())) ||
    (MODE === "PROD" && [173].includes(clientId()))
  );
}

export function enableAgreegateJournal() {
  const FE_ENABLE_AGREEGATE_JOURNAL_TOTALS = getConfigVariable(
    "FE_ENABLE_AGREEGATE_JOURNAL_TOTALS"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_AGREEGATE_JOURNAL_TOTALS.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_AGREEGATE_JOURNAL_TOTALS.includes(clientId()))
  );
}

export function enableCreditApplication() {
  const FE_ENABLE_CREDIT_APPLICATION = getConfigVariable(
    "FE_ENABLE_CREDIT_APPLICATION"
  );
  return (
    MODE === "DEV" ||
    (MODE === "PROD" && FE_ENABLE_CREDIT_APPLICATION.includes(clientId()))
  );
}

export function enableBankBalanceReport(configVariables) {
  const FE_ENABLE_BANK_BALANCE_REPORT = getConfigVariable(
    "FE_ENABLE_BANK_BALANCE_REPORT",
    configVariables
  );

  return FE_ENABLE_BANK_BALANCE_REPORT.includes(Number(clientId()));
}

export function enableForVoltyx() {
  //no migration to be done as very specific function for voltyx
  return (
    (MODE === "DEV" && clientId() === 72) ||
    (MODE === "PROD" && [145, 153, 154, 155].includes(clientId()))
  );
}

export function enableDefaultAllDateFilter() {
  const FE_ENABLE_DEFAULT_ALL_DATE_FILTER = getConfigVariable(
    "FE_ENABLE_DEFAULT_ALL_DATE_FILTER"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_DEFAULT_ALL_DATE_FILTER.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_DEFAULT_ALL_DATE_FILTER.includes(clientId()))
  );
}

export function disableCustomerTabForOpenEye() {
  // no migration to be done as very specific function for openeye
  return (
    (MODE === "DEV" &&
      TokenManager.isCustomer() &&
      [95].includes(clientId())) ||
    (MODE === "PROD" && TokenManager.isCustomer() && [111].includes(clientId()))
  );
}

export function enableCustomFieldsCSV() {
  return (
    (MODE === "DEV" && [89, 188].includes(clientId())) ||
    (MODE === "PROD" && [116, 164].includes(clientId()))
  );
}

export function enableOBTabs() {
  const FE_ENABLE_OB_TABS = getConfigVariable("FE_ENABLE_OB_TABS");
  return (
    (MODE === "DEV" && FE_ENABLE_OB_TABS.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_OB_TABS.includes(clientId()))
  );
}

export function enableForShouti() {
  // no migration to be done as very specific function for shouti
  return (
    (MODE === "DEV" && clientId() === 53) ||
    (MODE === "PROD" && clientId() === 27)
  );
}

export function enableCategoryViewCF() {
  const FE_ENABLE_CF_NESTED_CATEGORY_VIEW = getConfigVariable(
    "FE_ENABLE_CF_NESTED_CATEGORY_VIEW"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_CF_NESTED_CATEGORY_VIEW.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_CF_NESTED_CATEGORY_VIEW.includes(clientId()))
  );
}

export function enableTimecardUpload() {
  // TBD
  return (
    (MODE === "DEV" && [112].includes(clientId())) ||
    (MODE === "PROD" && [182].includes(clientId()))
  );
}

export function enableFileUpload() {
  const FE_ENABLE_CUSTOMER_DETAILS_FILE_UPLOAD = getConfigVariable(
    "FE_ENABLE_CUSTOMER_DETAILS_FILE_UPLOAD"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_CUSTOMER_DETAILS_FILE_UPLOAD.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_CUSTOMER_DETAILS_FILE_UPLOAD.includes(clientId()))
  );
}

export function enableStatementFileNameToEntity() {
  const FE_ENABLE_ENTITY_NAME_IN_MANUAL_STATEMENT_FILE = getConfigVariable(
    "FE_ENABLE_ENTITY_NAME_IN_MANUAL_STATEMENT_FILE"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_ENTITY_NAME_IN_MANUAL_STATEMENT_FILE.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_ENTITY_NAME_IN_MANUAL_STATEMENT_FILE.includes(clientId()))
  );
}

export function enableCurrencyDropdownInPayment() {
  const FE_ENABLE_CURRENCY_DROPDOWN_IN_PAYMENT_MODAL = getConfigVariable(
    "FE_ENABLE_CURRENCY_DROPDOWN_IN_PAYMENT_MODAL"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_CURRENCY_DROPDOWN_IN_PAYMENT_MODAL.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_CURRENCY_DROPDOWN_IN_PAYMENT_MODAL.includes(clientId()))
  );
}

export function enableEasyPayPG() {
  const accountsData = TokenManager && TokenManager.getPaymentAccountTypeData();
  return accountsData && accountsData.account_type === "EASYPAY";
}
export function enableWorldPayPG() {
  const accountsData = TokenManager && TokenManager.getPaymentAccountTypeData();
  return accountsData && accountsData.account_type === "WORLDPAY";
}

export function enableFortisPG() {
  const accountsData = TokenManager && TokenManager.getPaymentAccountTypeData();
  return accountsData && accountsData.account_type === "FORTIS";
}

export function enableStripePG() {
  const accountsData = TokenManager && TokenManager.getPaymentAccountTypeData();
  return (
    accountsData &&
    (!accountsData.account_type || accountsData.account_type === "STRIPE")
  );
}

export function enableWPSPG() {
  const accountsData = TokenManager && TokenManager.getPaymentAccountTypeData();
  return accountsData && accountsData.account_type === "WILEY";
}

export function enableSAP_DPA() {
  const accountsData = TokenManager && TokenManager.getPaymentAccountTypeData();
  return accountsData && accountsData.account_type === "DPA";
}

export function enableForGoVirtual() {
  return MODE === "DEV" && [203, 181, 89].includes(clientId());
}

export const enableMiscLinesGrouping = () => true;

export const getCustomerNameFromRel = () => {
  const FE_ENABLE_CUSTOMER_NAME_FROM_REL = getConfigVariable(
    "FE_ENABLE_CUSTOMER_NAME_FROM_REL"
  );
  return (
    MODE === "PROD" && FE_ENABLE_CUSTOMER_NAME_FROM_REL.includes(clientId())
  );
};

export function enableWeeklyToggle() {
  const FE_ENABLE_WEEKLY_TOGGLE_IN_DSO_DPO_CHART = getConfigVariable(
    "FE_ENABLE_WEEKLY_TOGGLE_IN_DSO_DPO_CHART"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_WEEKLY_TOGGLE_IN_DSO_DPO_CHART.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_WEEKLY_TOGGLE_IN_DSO_DPO_CHART.includes(clientId()))
  );
}

export function enableForArDemo() {
  const FE_ENABLE_AR_DEMO_FEATURES = getConfigVariable(
    "FE_ENABLE_AR_DEMO_FEATURES"
  );
  return (
    (MODE === "DEV" && FE_ENABLE_AR_DEMO_FEATURES.includes(clientId())) ||
    (MODE === "PROD" && FE_ENABLE_AR_DEMO_FEATURES.includes(clientId()))
  );
}

export function enableSelectAllInvoicePaymentDemo() {
  const FE_ENABLE_SELECT_ALL_INVOICE_PAYMENT_DEMO = getConfigVariable(
    "FE_ENABLE_SELECT_ALL_INVOICE_PAYMENT_DEMO"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_SELECT_ALL_INVOICE_PAYMENT_DEMO.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_SELECT_ALL_INVOICE_PAYMENT_DEMO.includes(clientId()))
  );
}

export function enableForHardHat() {
  // no migration to be done as very specific function for hardhat
  return (
    (MODE === "DEV" && clientId() === 198) ||
    (MODE === "PROD" && clientId() === 173)
  );
}

export function isEntityLevelCurrencyClient() {
  // Clients with no single client-wide currency -- each corporate entity
  // carries its own base currency. List is backend-driven so clients can be
  // added/removed without a frontend deploy.
  const FE_CLIENT_IDS_FOR_ENTITY_LEVEL_CURRENCY = getConfigVariable(
    "FE_CLIENT_IDS_FOR_ENTITY_LEVEL_CURRENCY"
  );
  return (
    MODE === "PROD" &&
    FE_CLIENT_IDS_FOR_ENTITY_LEVEL_CURRENCY.includes(clientId())
  );
}

export function enableOnlyForDev() {
  return MODE === "DEV";
}

export function enableCustomerInvoiceRestrictedCreation() {
  const FE_ENABLE_CUSTOMER_INVOICE_RESTRICTED_CREATION = getConfigVariable(
    "FE_ENABLE_CUSTOMER_INVOICE_RESTRICTED_CREATION"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_CUSTOMER_INVOICE_RESTRICTED_CREATION.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_CUSTOMER_INVOICE_RESTRICTED_CREATION.includes(clientId()))
  );
}

export function offsetArApForLampplus() {
  const FE_ENABLE_OFFSET_AR_AP_FOR_LAMPPLUS = getConfigVariable(
    "FE_ENABLE_OFFSET_AR_AP_FOR_LAMPPLUS"
  );
  return (
    (MODE === "DEV" &&
      FE_ENABLE_OFFSET_AR_AP_FOR_LAMPPLUS.includes(clientId())) ||
    (MODE === "PROD" &&
      FE_ENABLE_OFFSET_AR_AP_FOR_LAMPPLUS.includes(clientId()))
  );
}

export function disablePartialInvoicePayment() {
  const FE_DISABLE_PARTIAL_PAYMENTS = getConfigVariable(
    "FE_DISABLE_PARTIAL_PAYMENTS"
  );
  return (
    (MODE === "DEV" && FE_DISABLE_PARTIAL_PAYMENTS.includes(clientId())) ||
    (MODE === "PROD" && FE_DISABLE_PARTIAL_PAYMENTS.includes(clientId()))
  );
}

export function isWileyClient() {
  const FE_CLIENT_IDS_FOR_WILEY = getConfigVariable("FE_CLIENT_IDS_FOR_WILEY");
  return (
    (MODE === "PROD" && FE_CLIENT_IDS_FOR_WILEY.includes(clientId())) ||
    (MODE === "DEV" && FE_CLIENT_IDS_FOR_WILEY.includes(clientId()))
  );
}

export function isWileyProdClient() {
  const FE_CLIENT_IDS_FOR_WILEY_WPS_PRODUCTION = [224]; // this is used for changing JS source for wiley prod environment.
  return (
    MODE === "PROD" &&
    FE_CLIENT_IDS_FOR_WILEY_WPS_PRODUCTION.includes(clientId())
  );
}

export function isWileyClientFECheck() {
  return (
    (MODE === "PROD" &&
      [
        CLIENTS.WILEY_PROD,
        CLIENTS.WILEY_PROD_QA,
        CLIENTS.WILEY_PROD_DEV,
        CLIENTS.WILEY_PROD_DEV2,
        CLIENTS.WILEY_PROD_EQ3,
        CLIENTS.WILEY_PROD_EU,
      ].includes(clientId())) ||
    (MODE === "DEV" && clientId() === CLIENTS.WILEY_DEV)
  );
}

export function enableUseCreditMemoPayment() {
  const FE_ENABLE_USE_CREDIT_MEMO = getConfigVariable(
    "FE_ENABLE_USE_CREDIT_MEMO"
  );
  return (
    (MODE === "PROD" && FE_ENABLE_USE_CREDIT_MEMO.includes(clientId())) ||
    MODE === "DEV"
  );
}

export function enableUseDeductionCodeInPayment() {
  const FE_ENABLE_USE_DEDUCTION_CODE = getConfigVariable(
    "FE_ENABLE_USE_DEDUCTION_CODE"
  );
  return (
    (MODE === "PROD" && FE_ENABLE_USE_DEDUCTION_CODE.includes(clientId())) ||
    MODE === "DEV"
  );
}

export function enableForAIR() {
  // no migration to be done as very specific function for AIR
  return (
    (MODE === "DEV" && [114].includes(clientId())) ||
    (MODE === "PROD" && [200].includes(clientId()))
  );
}

export function enableStripeTestAccountOnProd() {
  const FE_ENABLE_STRIPE_TEST_CONNECTION_ON_PROD = getConfigVariable(
    "FE_ENABLE_STRIPE_TEST_CONNECTION_ON_PROD"
  );
  return (
    MODE === "DEV" ||
    (MODE === "PROD" &&
      FE_ENABLE_STRIPE_TEST_CONNECTION_ON_PROD.includes(clientId()))
  );
}

export function enablePayStatementBtn() {
  const FE_ENABLE_PAY_STATEMENT_BUTTON = getConfigVariable(
    "FE_ENABLE_PAY_STATEMENT_BUTTON"
  );
  return MODE === "DEV" || FE_ENABLE_PAY_STATEMENT_BUTTON.includes(clientId());
}

export function enableMultipleRemittanceFileProcess() {
  const FE_ENABLE_MULTI_REMITTANCE_FILE_PROCESSING = getConfigVariable(
    "FE_ENABLE_MULTI_REMITTANCE_FILE_PROCESSING"
  );
  return FE_ENABLE_MULTI_REMITTANCE_FILE_PROCESSING.includes(clientId());
}

export function enableDEVOnly() {
  return MODE === "DEV";
}

export function enableDemoRemittanceFlow() {
  return MODE === "DEV" && clientId() === 114;
}

export function enablePerPageSelector() {
  const FE_ENABLE_PER_PAGE_RECORD_SELECTOR = getConfigVariable(
    "FE_ENABLE_PER_PAGE_RECORD_SELECTOR"
  );
  return FE_ENABLE_PER_PAGE_RECORD_SELECTOR.includes(clientId());
}

export function arAgingAllowedEditClient() {
  const FE_ENABLE_AR_ENTITY_BUCKETS = getConfigVariable(
    "FE_ENABLE_AR_ENTITY_BUCKETS"
  );
  if (MODE === "DEV") {
    return true;
  }
  return FE_ENABLE_AR_ENTITY_BUCKETS.includes(clientId());
}

export function enablePayIqDateWorkflowOption() {
  const FE_CLIENT_IDS_FOR_PAYIQ_DATE_WORKFLOW_OPTION = getConfigVariable(
    "FE_CLIENT_IDS_FOR_PAYIQ_DATE_WORKFLOW_OPTION"
  );
  return (
    (MODE === "PROD" &&
      FE_CLIENT_IDS_FOR_PAYIQ_DATE_WORKFLOW_OPTION.includes(clientId())) ||
    (MODE === "DEV" &&
      FE_CLIENT_IDS_FOR_PAYIQ_DATE_WORKFLOW_OPTION.includes(clientId()))
  );
}
